import {i18n} from '@online-offer/i18n';
import {SectionPrint} from '@online-offer/shared';
import {Show, Text, VStack} from 'platform/foundation';
import {useLocale} from 'platform/locale';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {FeatureCategoryRow} from '../../components/FeatureCategoryRow/FeatureCategoryRow';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getFeatures} from '../../utils/getFeatures';

/**
 * The PDF always has room for three columns. A literal keeps the layout independent of
 * whether the rendering browser reports the `printer` device.
 */
const FEATURE_COLUMNS = 3;

export function FeaturesPrint() {
  const {vehicle, alphaCatalogue} = useGetOnlineOfferData();
  const locale = useLocale();
  const features = getFeatures({
    vehicle,
    alphaCatalogue,
    language: locale.language,
  });

  const shouldShowFeatures = features.length > 0;
  const shouldShowAdditionalInformation = isNotNilOrEmpty(vehicle?.featuresByManufacturer);

  if (!shouldShowFeatures && !shouldShowAdditionalInformation) {
    return null;
  }

  return (
    <SectionPrint heading={i18n.t('features.heading')}>
      <VStack spacing={7}>
        <Show when={shouldShowFeatures}>
          <VStack spacing={9}>
            {features.map((category) => (
              <FeatureCategoryRow
                key={category.categoryKey}
                category={category}
                columns={FEATURE_COLUMNS}
              />
            ))}
          </VStack>
        </Show>
        <Show when={shouldShowAdditionalInformation}>
          <VStack spacing={2}>
            <Text size="large" alternative>
              {i18n.t('features.additionalInformation')}
            </Text>
            <Text size="small">{vehicle?.featuresByManufacturer}</Text>
          </VStack>
        </Show>
      </VStack>
    </SectionPrint>
  );
}
